import styles from "./style.module.scss";
import VLImagesCarouselPreview, {
  ImageObj,
} from "views/uikit/VLCarousel/VLImagesCarouselPreview";
import { Option } from "views/uikit/FormFields/SelectList";
import { useState } from "react";
import ReviewModalHeader from "./ReviewModalHeader";
import ReviewModalClassesList from "./ReviewModalClassesList";
import { Modal } from "antd";

interface ReviewModalProps {
  open?: boolean;
  onClose: () => void;
  labelsOptions: Option[];
  initialSelectedItem?: number;
  imagesList: (ImageObj & { labelId?: string; id: string })[];
  selectedLabel?: string;
  onCheckBoxClick?: (item: {
    labelId: string;
    sampleId: string;
  }) => Promise<void>;
  counters?: { total: number; forReview: number };
}

export default function ReviewModal({
  imagesList,
  open = false,
  onClose,
  initialSelectedItem,
  labelsOptions,
  selectedLabel,
  onCheckBoxClick,
  counters,
}: ReviewModalProps) {
  const [selectedItem, setSelectedItem] = useState(initialSelectedItem);
  const selected =
    selectedItem !== undefined ? imagesList[selectedItem] : undefined;

  return (
    <Modal open={open} onCancel={onClose} width={`70%`} footer={false} centered>
      <ReviewModalHeader counters={counters} selectedLabel={selectedLabel} />
      <div className={styles.wrapper}>
        <div className={styles.carouselWrapper}>
          <VLImagesCarouselPreview
            imagesList={imagesList}
            selectedItem={selectedItem}
            afterChange={(e) => setSelectedItem(e)}
          />
        </div>
        <ReviewModalClassesList
          labelsOptions={labelsOptions}
          selected={selected}
          onCheckBoxClick={async (e) => {
            if (!onCheckBoxClick) return;
            await onCheckBoxClick(e);
          }}
          className={styles.list}
        />
      </div>
    </Modal>
  );
}
